import { render, staticRenderFns } from "./program_scheme.vue?vue&type=template&id=93caa966&scoped=true"
import script from "./program_scheme.vue?vue&type=script&lang=js"
export * from "./program_scheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93caa966",
  null
  
)

export default component.exports